module.exports = __webpack_public_path__ + "assets/img/1608.b23d952c.png";